import * as Types from '../../tenants/kwg/generated';

import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';


export const DistinctValuesDocument = `
    query DistinctValues($list: DistinctValuesList!, $field: String!, $search: String) {
  distinctValues(list: $list, field: $field, search: $search) {
    values
    hasMore
    supported
  }
}
    `;

export const useDistinctValuesQuery = <
      TData = Types.DistinctValuesQuery,
      TError = unknown
    >(
      variables: Types.DistinctValuesQueryVariables,
      options?: Omit<UseQueryOptions<Types.DistinctValuesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.DistinctValuesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.DistinctValuesQuery, TError, TData>(
      {
    queryKey: ['DistinctValues', variables],
    queryFn: fetcher<Types.DistinctValuesQuery, Types.DistinctValuesQueryVariables>(DistinctValuesDocument, variables),
    ...options
  }
    )};

export const useSuspenseDistinctValuesQuery = <
      TData = Types.DistinctValuesQuery,
      TError = unknown
    >(
      variables: Types.DistinctValuesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<Types.DistinctValuesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<Types.DistinctValuesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<Types.DistinctValuesQuery, TError, TData>(
      {
    queryKey: ['DistinctValues', variables],
    queryFn: fetcher<Types.DistinctValuesQuery, Types.DistinctValuesQueryVariables>(DistinctValuesDocument, variables),
    ...options
  }
    )};

export const useInfiniteDistinctValuesQuery = <
      TData = InfiniteData<Types.DistinctValuesQuery>,
      TError = unknown
    >(
      variables: Types.DistinctValuesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<Types.DistinctValuesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<Types.DistinctValuesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<Types.DistinctValuesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DistinctValues.infinite', variables],
      queryFn: (metaData) => fetcher<Types.DistinctValuesQuery, Types.DistinctValuesQueryVariables>(DistinctValuesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

export const useSuspenseInfiniteDistinctValuesQuery = <
      TData = InfiniteData<Types.DistinctValuesQuery>,
      TError = unknown
    >(
      variables: Types.DistinctValuesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<Types.DistinctValuesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<Types.DistinctValuesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<Types.DistinctValuesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DistinctValues.infinite', variables],
      queryFn: (metaData) => fetcher<Types.DistinctValuesQuery, Types.DistinctValuesQueryVariables>(DistinctValuesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};
